/* eslint-disable no-unused-vars */

import { REQUEST_ABOUT_US_INFO } from "@/store/actions/aboutUs";
import apiCall from "@/utils/api";

const state = {
  aboutUsInfo: {},
};

const getters = {
  getAboutUsInfo: (state) => state.aboutUsInfo,
};

const actions = {
  [REQUEST_ABOUT_US_INFO]: async ({ commit, dispatch, rootGetters }) => {
    let request = await apiCall({
      url: `about-us/${rootGetters.getLanguage}`,
    });

    commit(REQUEST_ABOUT_US_INFO, request);
    return request;
  },
};

const mutations = {
  [REQUEST_ABOUT_US_INFO]: (state, response) => {
    state.aboutUsInfo = response;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
